/**
 * Exposes Platform REST endpoints.
 *
 * @module PlatformProxy
 * @version 3.0.0
 * @requires Proxy
 */
//import { endpoints, paths } from 'proxies/config';
import proxy from './proxy';

let apiUrl = '';

export default function initPlatformProxy(url: string) {
  apiUrl = url;
}

/**
 * Gets a list of all applications the user has access to.
 *
 */
const getApplications = () => {
  const headerConfig = {
    headers: {
      'Content-Type': 'application/json',
      'api-version': 3,
      'dhi-service-id': 'iam',
    },
  };
  return proxy.http.get(apiUrl + '/api/admin/feature/tenant/list', headerConfig);
};

const getCapabilities = (projectId: string) => {
  const headerConfig = {
    headers: {
      'Content-Type': 'application/json',
      'api-version': 3     
    },
  };
  return proxy.http.get(apiUrl + `/api/metadata/project/${projectId}/capabilities`, headerConfig);
};

const getSASToken = (projectId: string) => {
  const headerConfig = {
    headers: {
      'api-version': 1,
    },
  };
  return proxy.http.get(apiUrl + `/api/services/sastoken?projectId=${projectId}`, headerConfig);
};

const getUserTenants = () => {
  const headerConfig = {
    headers: {
      'api-version': 3,
      'dhi-service-id': 'iam',
    },
  };
  return proxy.http.get(apiUrl + `/api/iam/tenant/my`, headerConfig);
};

export const PlatformProxy = {
  initPlatformProxy,
  getApplications,
  getSASToken,
  getUserTenants,
  getCapabilities
};
